import React from 'react'
import { ServiceContainer, ServiceWrapper, Service, ServiceContent, ServiceHead, ServiceP } from './Services2Element'


const Service1 = () => {
    return (
        <ServiceContainer>
            <ServiceWrapper>
                <Service>
                <ServiceContent data-aos="fade-down">
                    <ServiceHead>Welcome to the world of Premium design</ServiceHead>
                    <ServiceP>Lorem ipsum, dolor sit amet consectetur adipisicing elit. 
                Aliquam enim iure alias nulla mollitia soluta hic distinctio
                 corporis aspernatur possimus Lorem ipsum, dolor sit amet consectetur adipisicing elit. 
                Aliquam enim iure alias nulla mollitia soluta hic distinctio
                 corporis aspernatur possimus  dolor sit amet consectetur adipisicing elit. 
                Aliquam enim iure alias nulla mollitia soluta hic distinctio
                 corporis aspernatur possimus Lorem ipsum, dolor sit amet consectetur adipisicing elit. 
                Aliquam enim iure alias nulla mollitia soluta hic distinctio
                 corporis aspernatur possimus</ServiceP>
                </ServiceContent>                
                
                

               
                </Service>


                
            </ServiceWrapper>
        </ServiceContainer>
    )
}

export default Service1

